import { memo } from 'react';

const AuthSplitLayout = memo(({ children }) => (
  <div className="flex min-h-dvh w-full flex-col bg-white lg:flex-row">{children}</div>
));

AuthSplitLayout.displayName = 'AuthSplitLayout';

export default AuthSplitLayout;
